module.exports = "fragment MinimalContactFragment on Contact {\n  id\n  firstName\n  lastName\n}\n"